import { MailFilled } from "@ant-design/icons";
import { Button, Divider, Flex, Input } from "antd";
import { useFormik } from "formik";
import { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useRegisterMutation } from "../api/api";
import ErrorPanel from "../components/error.panel.component";
import { useLayoutContext } from "../providers/layout.provider";
import { ROUTES } from "../utils/constants";
import { getRecaptchaKey, isRecaptchaEnabled } from "../utils/functions";
import { useNotifications2 } from "../components/notifications/notification";

export default function RegisterPage() {
  const { mutateAsync, isPending: isLoading } = useRegisterMutation();

  const { isMobile } = useLayoutContext();
  const { notification, notifyError } = useNotifications2();

  const [recaptchaVerified, setRecaptchaVerified] =
    useState(!isRecaptchaEnabled);

  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      password: "",
      email: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(8, "Minimum of 8 characters")
        .required("Password is required"),
      email: Yup.string()
        .matches(
          /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/,
          "Please enter valid email address",
        )
        .required("Please enter email."),
    }),
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: async (values) => {
      mutateAsync(values)
        .then(() => {
          navigate(ROUTES.LOGIN + "?register=success");
        })
        .catch((e) => {
          let msg = "Whoops! Something went wrong. Please try again.";
          if (
            e.response?.data?.message ===
            "An account already exists with this email."
          ) {
            msg = e.response?.data?.message;
          }
          notifyError(msg);
        });
    },
  });

  const setLoginReady = (e: any) => {
    setRecaptchaVerified(true);
  };

  return (
    <div
      style={{
        backgroundColor: "#232323",
        color: "#e0e0e0",
      }}
      className={`splitright ${isMobile ? "mobile-splitright my-20" : ""}`}
    >
      {notification}
      <div className={`${isMobile ? "divColumn" : "divFlex mt-10 mb-80 "}`}>
        <div className="divCenterAlign w-100 divColumn">
          <div className="w-100 divRight" style={{ marginRight: 30 }}>
            <Flex gap={5}>
              <MailFilled />
              <a
                href="mailto:sales@expensehut.com"
                style={{ color: "white", textDecoration: "none" }}
              >
                sales@expensehut.com
              </a>
            </Flex>
          </div>

          <div className="divCenterAlign">
            <h2 style={{ color: "var(--exhut-ramar-blue)" }}>Driver Signup</h2>
          </div>

          <div className="mx-20">
            {isLoading && <div className="divCenterAlign"></div>}
          </div>

          <form
            onSubmit={formik.handleSubmit}
            style={{ border: "1px solid grey", padding: 40, borderRadius: 20 }}
          >
            <Flex vertical gap={0}>
              <Flex gap={20} vertical>
                <strong className="font-larger">Email</strong>

                <div>
                  <Input
                    style={{ width: 300 }}
                    {...formik.getFieldProps("email")}
                  />
                  <ErrorPanel message={formik.errors.email} />
                </div>
              </Flex>

              <Flex gap={20} vertical>
                <strong className="font-larger">Password</strong>

                <div>
                  <Input
                    style={{ width: 300 }}
                    type="password"
                    {...formik.getFieldProps("password")}
                  />
                  <ErrorPanel message={formik.errors.password} />
                </div>
              </Flex>
            </Flex>

            <div className="divCenterAlign mt-40">
              {isRecaptchaEnabled && (
                <ReCAPTCHA
                  sitekey={getRecaptchaKey()}
                  onChange={setLoginReady}
                />
              )}
            </div>

            <Flex vertical gap={30} className="divCenterAlign mt-40">
              <Button
                onClick={formik.submitForm}
                style={{ width: 300 }}
                type="primary"
                disabled={!recaptchaVerified}
              >
                Register{" "}
              </Button>
            </Flex>

            <div className="divColumn">
              <div className="my-20">
                <Link to="/login">Already registered?</Link>
              </div>
            </div>
          </form>
        </div>
      </div>

      <Divider />
    </div>
  );
}
